import React from 'react';
import { Route } from 'react-router-dom';

import { AppHeader } from 'layout/appHeader';
import { AppSideBar } from 'layout/appSideBar';

import { useRouter } from '../components';
import { useAuth } from 'auth';

const DashboardLayout = ({ children, ...rest }) => {
  const { Redirect } = useRouter();
  const auth = useAuth();

  React.useEffect(() => {
    const checkAuth = async() => {
      if (!(await auth.loggedIn())) {
        return <Redirect to="/admin/login" />
      }
    }
    checkAuth();
  }, [auth]);

  return (
    <div className="app-container app-theme-white fixed-header fixed-sidebar fixed-footer">
      <AppHeader />
      <div className="appMain">
        <AppSideBar />
        <div className="appMain__outer">
          <div className="appMain__inner">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

const DashboardLayoutRoute = ({ component: RenderComponent, ...rest }) => {
  return (
    <Route {...rest} render={matchProps => (
      <DashboardLayout>
        <RenderComponent {...matchProps} />
      </DashboardLayout>
    )} />
  )
};

export default DashboardLayoutRoute;